import classnames from 'classnames/bind';
import React from 'react';
import { getIcon } from '@uifabric/styling/lib/utilities/icons';
import { getRTL } from '@uifabric/utilities/lib/rtl';
import { SvgIconStylesContext } from './SvgIconStylesContext';
import type { FluentSvgIconProps } from '../schema/FluentSvgIcon.types';

const styles = require('./FluentSvgIcon.scss');
const cx = classnames.bind(styles);

const DEFAULT_ICON_DEFINITION = {
    subset: {
        className: undefined,
    },
    code: undefined,
};

export const FluentSvgIcon = React.forwardRef(
    (props: FluentSvgIconProps, ref?: React.RefObject<any>): JSX.Element => {
        const { icon, iconStyles, iconContainerStyles, ...remainingProps } = props;
        const iconDefinition = getIcon(icon) || DEFAULT_ICON_DEFINITION;

        const svgRTLStyles = getRTL() && iconsToFlipInRTL[icon] ? styles.svgRTL : null;
        const stylesContextValue = { iconStyles: cx(styles.svg, svgRTLStyles, iconStyles) };

        return (
            <SvgIconStylesContext.Provider value={stylesContextValue}>
                <i
                    ref={ref}
                    aria-hidden={true}
                    data-icon-name={icon}
                    className={cx('root', iconContainerStyles)}
                    {...remainingProps}>
                    {iconDefinition.code}
                </i>
            </SvgIconStylesContext.Provider>
        );
    }
);

// TODO: Move the flip responsibility at an icon level later instead of this top level approach
// We are adding only the icons we are being used in the app to reduce bloating
const iconsToFlipInRTL: Record<string, boolean> = {
    ChevronLeftFilled: true,
    ChevronRightRegular: true,
    ChevronRightFilled: true,
    ArrowLeftRegular: true,
    ArrowRightRegular: true,
    ArrowForwardRegular: true,
    ArrowReplyRegular: true,
    ArrowReplyAllRegular: true,
    FolderArrowRightRegular: true,
    ArrowCircleLeftRegular: true,
    ArrowCircleRightRegular: true,
    CalendarArrowRightRegular: true,
    CalendarReplyRegular: true,
    SendRegular: true,
    ListRegular: true,
    TextDescriptionRegular: true,
    QuestionRegular: true,
    QuestionCircleFilled: true,
    PresenceQuestionFilled: true,
    PresenceQuestionRegular: true,
    QuestionCircleRegular: true,
    SignOutRegular: true,
    CalendarLtrRegular: true,
    CalendarLtrFilled: true,
    VoicemailArrowForwardRegular: true,
    VoicemailArrowBackRegular: true,
};
